/* Modimania — Outil « Quels modèles puis-je faire avec mes perles ? » (v4, porté Shopify : calcul client sur data.json) */
( function() {
	'use strict';

	var root = document.querySelector( '[data-mdm-corr]' );
	if ( ! root ) { return; }

	var resultsWrap = root.querySelector( '[data-mdm-corr-results]' );
	var DATA_URL = ( window.MDM && MDM.data ) || 'https://cdn.shopify.com/s/files/1/0951/0069/9005/files/modimania-data-v9.json?v=1788271291';
	var COLORS = {H02:['#FFFAD2','Blanc / Crème'],H03:['#FFD700','Jaune'],H05:['#D92C2C','Rouge'],H06:['#FFC0CD','Rose'],H07:['#7B57B2','Violet'],H08:['#003399','Bleu foncé'],H10:['#3A8F46','Vert'],H104:['#C0E74F','Vert citron'],H107:['#666699','Lavande'],H116:['#000000','Noir'],H18:['#000000','Noir'],H21:['#B47D29','Marron clair'],H22:['#B3202A','Rouge foncé'],H09:['#0066CC','Bleu'],H36:['#0066CC','Bleu'],H45:['#BFA4DD','Violet pastel'],H46:['#A3CFE9','Bleu pastel'],H49:['#A3CFE9','Bleu pastel'],H105:['#F6C1A3','Orange Abricot clair'],H60:['#F6C1A3','Orange Abricot clair'],H70:['#CCCCCC','Gris clair'],H71:['#4B4B4B','Gris foncé'],H75:['#E6C9B3','Beige café'],H79:['#F4A86E','Orange Abricot'],H84:['#6B8F24','Vert olive']};

	/* Sachets vendus à l'unité : code couleur -> id de variante Shopify.
	   Surchargeable depuis Liquid via window.MDM.sachets (métachamp shop.modimania.sachets). */
	var SACHETS = ( window.MDM && MDM.sachets ) || {H02:58549480784253,H03:58549480817021,H05:58549463548285,H06:58549480882557,H07:58549480948093,H08:58549480980861,H09:58549481046397,H10:58549481079165,H18:58549482586493,H21:58549482619261,H22:58549482684797,H45:58549482717565,H46:58549482750333,H70:58549482783101,H71:58549482815869,H75:58549484290429,H79:58549484323197,H84:58549484355965,H104:58549484421501,H105:58549484454269,H107:58549484519805};

	var PRIX = 3.00, PAR_SACHET = 1000;
	var _models = null;

	function loadModels() {
		if ( _models ) { return Promise.resolve( _models ); }
		return fetch( DATA_URL ).then( function( r ) { return r.json(); } ).then( function( j ) {
			j.forEach(function(m){if(m.materiel){if(m.materiel.H36!==undefined){m.materiel.H09=(m.materiel.H09||0)+m.materiel.H36;delete m.materiel.H36;}if(m.materiel.H49!==undefined){m.materiel.H46=(m.materiel.H46||0)+m.materiel.H49;delete m.materiel.H49;}if(m.materiel.H60!==undefined){m.materiel.H105=(m.materiel.H105||0)+m.materiel.H60;delete m.materiel.H60;}if(m.materiel.H116!==undefined){m.materiel.H18=(m.materiel.H18||0)+m.materiel.H116;delete m.materiel.H116;}}});
			j.forEach( function( m ) { m._titre = m.perso + ' en perles à repasser'; /* 11 oct. 2026 : vocabulaire « perles à repasser » */ m._q = ( m.perso || '' ).toLowerCase(); if ( m.modele_url && 0 === m.modele_url.indexOf( '/modeles/' ) ) { m.modele_url = '/pages' + m.modele_url; } } );
			_models = j; return j;
		} );
	}
	function esc( s ) {
		var d = document.createElement( 'div' );
		d.textContent = s == null ? '' : String( s );
		return d.innerHTML;
	}
	function escAttr( s ) { return esc( s ).replace( /"/g, '&quot;' ); }
	function euro( n ) { return ( Math.round( n * 100 ) / 100 ).toFixed( 2 ).replace( '.', ',' ); }
	function intFr( n ) { return String( n ).replace( /\B(?=(\d{3})+(?!\d))/g, ' ' ); }
	function cap( s ) { return s ? s.charAt( 0 ).toUpperCase() + s.slice( 1 ) : s; }
	function debounce( fn, d ) {
		var t = null;
		return function() { var a = arguments, c = this; if ( t ) { clearTimeout( t ); } t = setTimeout( function() { fn.apply( c, a ); }, d ); };
	}

	/* ---------- Onglets ---------- */
	var tabs = Array.prototype.slice.call( root.querySelectorAll( '.mdm-corr-tab' ) );
	var panes = Array.prototype.slice.call( root.querySelectorAll( '.mdm-corr-pane' ) );
	function activate( tab ) {
		tabs.forEach( function( t ) { t.classList.remove( 'is-active' ); t.setAttribute( 'aria-selected', 'false' ); } );
		panes.forEach( function( p ) { p.hidden = true; } );
		tab.classList.add( 'is-active' );
		tab.setAttribute( 'aria-selected', 'true' );
		var pane = root.querySelector( '#' + tab.getAttribute( 'aria-controls' ) );
		if ( pane ) { pane.hidden = false; }
	}
	tabs.forEach( function( tab ) { tab.addEventListener( 'click', function() { activate( tab ); } ); } );

	/* ---------- Algo (identique au serveur WP) ---------- */
	function stockRestant( m ) {
		var stock = {};
		Object.keys( m.materiel || {} ).forEach( function( code ) {
			var need = m.materiel[ code ];
			var achete = Math.ceil( need / PAR_SACHET ) * PAR_SACHET;
			var reste = Math.max( 0, achete - need );
			if ( reste > 0 ) { stock[ code ] = reste; }
		} );
		return stock;
	}
	function calc( stock, m ) {
		var besoin = m.materiel || {};
		var codes = Object.keys( besoin );
		var total = 0; codes.forEach( function( c ) { total += besoin[ c ]; } );
		if ( total <= 0 ) { return null; }
		var couvert = 0, manquantes = [], cout = 0, couleursOk = 0;
		codes.forEach( function( code ) {
			var need = besoin[ code ];
			var have = stock[ code ] || 0;
			couvert += Math.min( have, need );
			var deficit = need - have;
			if ( deficit <= 0 ) { couleursOk++; }
			if ( deficit > 0 ) {
				var sachets = Math.ceil( deficit / PAR_SACHET );
				var ligne = sachets * PRIX;
				cout += ligne;
				manquantes.push( { code: code, nom: ( COLORS[ code ] || [ 0, code ] )[ 1 ], hex: ( COLORS[ code ] || [ '#CBBFA8' ] )[ 0 ], deficit: deficit, sachets: sachets, cout: Math.round( ligne * 100 ) / 100 } );
			}
		} );
		return {
			match_pct: Math.round( 100 * couvert / total ),
			manquantes: manquantes,
			nb_manquantes: manquantes.length,
			cout_estime: Math.round( cout * 100 ) / 100,
			cout_connu: true,
			color_pct: codes.length ? Math.round( 100 * couleursOk / codes.length ) : 0,
			nb_couleurs: codes.length,
			couleurs_ok: couleursOk,
			total_sachets: manquantes.reduce( function( a, x ) { return a + x.sachets; }, 0 )
		};
	}
	function compute( stock, excludeRef ) {
		return loadModels().then( function( models ) {
			var items = [];
			models.forEach( function( m ) {
				if ( excludeRef && m.ref === excludeRef ) { return; }
				var c = calc( stock, m );
				if ( ! c ) { return; }
				c.titre = m._titre;
				c.url = m.modele_url;
				c.img = m.img;
				c.difficulte = cap( m.diff );
				items.push( c );
			} );
			items.sort( function( a, b ) {
				var ca = a.match_pct >= 100 ? 0 : 1;
				var cb = b.match_pct >= 100 ? 0 : 1;
				if ( ca !== cb ) { return ca - cb; }
				if ( 0 === ca ) { return a.nb_couleurs - b.nb_couleurs; }
				/* Modèles incomplets : pourcentage de réalisation décroissant d'abord,
				   puis, à pourcentage égal, le moins coûteux à compléter. */
				if ( b.match_pct !== a.match_pct ) { return b.match_pct - a.match_pct; }
				if ( a.cout_estime !== b.cout_estime ) { return a.cout_estime - b.cout_estime; }
				if ( a.nb_manquantes !== b.nb_manquantes ) { return a.nb_manquantes - b.nb_manquantes; }
				return b.color_pct - a.color_pct;
			} );
			return { items: items.slice( 0, 60 ), total: items.length };
		} );
	}

	/* ---------- Mode A : autocomplete modèle ---------- */
	var paneA = root.querySelector( '#mdm-corr-a' );
	var search = paneA ? paneA.querySelector( '.mdm-corr-search' ) : null;
	var acBox = paneA ? paneA.querySelector( '.mdm-corr-ac' ) : null;
	var goA = paneA ? paneA.querySelector( '.mdm-corr-go[data-mode="a"]' ) : null;
	var selectedRef = null;

	if ( search && acBox && goA ) {
		var doSuggest = debounce( function() {
			var q = search.value.trim().toLowerCase();
			selectedRef = null;
			goA.disabled = true;
			if ( q.length < 1 ) { acBox.hidden = true; acBox.innerHTML = ''; return; }
			loadModels().then( function( models ) {
				if ( search.value.trim().toLowerCase() !== q ) { return; }
				var hits = models.filter( function( m ) { return m._q.indexOf( q ) > -1; } ).slice( 0, 8 );
				if ( ! hits.length ) {
					acBox.innerHTML = '<div class="mdm-corr-ac-empty">Aucun modèle trouvé.</div>';
					acBox.hidden = false;
					return;
				}
				acBox.innerHTML = hits.map( function( m ) {
					var img = m.img ? '<img src="' + escAttr( m.img ) + '" alt="" loading="lazy">' : '<span class="mdm-corr-ac-noimg"></span>';
					return '<button type="button" class="mdm-corr-ac-item" data-ref="' + escAttr( m.ref ) + '" data-label="' + escAttr( m._titre ) + '">' + img + '<span>' + esc( m._titre ) + '</span></button>';
				} ).join( '' );
				acBox.hidden = false;
			} );
		}, 160 );

		search.addEventListener( 'input', doSuggest );
		search.addEventListener( 'focus', function() { if ( acBox.innerHTML.trim() && ! selectedRef ) { acBox.hidden = false; } } );

		acBox.addEventListener( 'click', function( e ) {
			var item = e.target.closest( '.mdm-corr-ac-item' );
			if ( ! item ) { return; }
			selectedRef = item.getAttribute( 'data-ref' );
			search.value = item.getAttribute( 'data-label' );
			acBox.hidden = true;
			goA.disabled = false;
		} );

		document.addEventListener( 'click', function( e ) {
			if ( paneA && ! paneA.contains( e.target ) ) { acBox.hidden = true; }
		} );

		goA.addEventListener( 'click', function() {
			if ( ! selectedRef ) { return; }
			run( { modele_source: selectedRef } );
		} );
	}

	/* ---------- Mode B : compteurs de perles ---------- */
	var paneB = root.querySelector( '#mdm-corr-b' );
	if ( paneB ) {
		paneB.addEventListener( 'click', function( e ) {
			var step = e.target.closest( '.mdm-corr-step' );
			if ( ! step ) { return; }
			var sw = step.closest( '.mdm-corr-swatch' );
			var qty = sw.querySelector( '.mdm-corr-qty' );
			var cur = parseInt( qty.value, 10 ) || 0;
			var delta = step.getAttribute( 'data-dir' ) === 'up' ? 100 : -100;
			cur = Math.max( 0, cur + delta );
			qty.value = cur;
			sw.classList.toggle( 'is-set', cur > 0 );
		} );
		paneB.addEventListener( 'input', function( e ) {
			if ( ! e.target.classList.contains( 'mdm-corr-qty' ) ) { return; }
			var v = parseInt( e.target.value, 10 ) || 0;
			if ( v < 0 ) { e.target.value = 0; v = 0; }
			e.target.closest( '.mdm-corr-swatch' ).classList.toggle( 'is-set', v > 0 );
		} );

		var goB = paneB.querySelector( '.mdm-corr-go[data-mode="b"]' );
		var resetB = paneB.querySelector( '.mdm-corr-reset' );
		if ( goB ) {
			goB.addEventListener( 'click', function() {
				var stock = {};
				paneB.querySelectorAll( '.mdm-corr-swatch' ).forEach( function( sw ) {
					var code = sw.getAttribute( 'data-code' );
					var qty = parseInt( sw.querySelector( '.mdm-corr-qty' ).value, 10 ) || 0;
					if ( code && qty > 0 ) { stock[ code ] = qty; }
				} );
				if ( ! Object.keys( stock ).length ) {
					resultsWrap.innerHTML = '<p class="mdm-corr-hint">Indiquez au moins une couleur pour lancer la recherche.</p>';
					return;
				}
				run( { stock: stock } );
			} );
		}
		if ( resetB ) {
			resetB.addEventListener( 'click', function() {
				paneB.querySelectorAll( '.mdm-corr-qty' ).forEach( function( q ) { q.value = 0; } );
				paneB.querySelectorAll( '.mdm-corr-swatch' ).forEach( function( s ) { s.classList.remove( 'is-set' ); } );
				resultsWrap.innerHTML = '';
			} );
		}
	}

	/* ---------- Calcul + rendu ---------- */
	function run( payload ) {
		resultsWrap.setAttribute( 'aria-busy', 'true' );
		resultsWrap.innerHTML = '<div class="mdm-corr-loading"><span class="mdm-corr-spin"></span> Calcul des correspondances…</div>';
		resultsWrap.scrollIntoView( { behavior: 'smooth', block: 'nearest' } );
		loadModels().then( function( models ) {
			var stock = {}, sourceTitre = '', excludeRef = null;
			if ( payload.modele_source ) {
				var src = null;
				models.forEach( function( m ) { if ( m.ref === payload.modele_source || ( m.modele_url || '' ).indexOf( payload.modele_source ) > -1 ) { src = m; } } );
				if ( ! src ) {
					resultsWrap.innerHTML = '<p class="mdm-corr-hint">Aucun résultat.</p>';
					return null;
				}
				stock = stockRestant( src );
				sourceTitre = src._titre;
				excludeRef = src.ref;
			} else {
				stock = payload.stock || {};
			}
			return compute( stock, excludeRef ).then( function( data ) {
				data.source_titre = sourceTitre;
				data.stock = Object.keys( stock ).map( function( code ) {
					return { code: code, nom: ( COLORS[ code ] || [ 0, code ] )[ 1 ], hex: ( COLORS[ code ] || [ '#CBBFA8' ] )[ 0 ], qte: stock[ code ] };
				} );
				render( data );
			} );
		} ).catch( function() {
			resultsWrap.innerHTML = '<p class="mdm-corr-error">Une erreur est survenue. Réessayez dans un instant.</p>';
		} ).then( function() { resultsWrap.removeAttribute( 'aria-busy' ); } );
	}

	function pctClass( p ) {
		if ( p >= 100 ) { return 'is-complet'; }
		if ( p >= 80 ) { return 'is-haut'; }
		if ( p >= 50 ) { return 'is-moyen'; }
		return 'is-bas';
	}

	function missingChips( manquantes ) {
		return manquantes.map( function( m ) {
			var label = m.nom + ' (' + m.code + ') — il manque ' + intFr( m.deficit ) + ' perles, soit ' + m.sachets + ' sachet' + ( m.sachets > 1 ? 's' : '' );
			var inner = '<span class="mdm-corr-miss-dot" style="background:' + escAttr( m.hex ) + '"></span><span class="mdm-corr-miss-q">+' + intFr( m.deficit ) + '</span>';
			return '<span class="mdm-corr-miss" title="' + escAttr( label ) + '">' + inner + '</span>';
		} ).join( '' );
	}

	/* Articles à AJOUTER au panier (pas un permalien /cart/ : celui-ci REMPLACE le
	   panier existant et saute au paiement — le client perdrait son kit).
	   Renvoie null si une des couleurs manquantes n'est pas vendue à l'unité. */
	function cartItems( manquantes ) {
		var items = [];
		for ( var i = 0; i < manquantes.length; i++ ) {
			var id = SACHETS[ manquantes[ i ].code ];
			if ( ! id ) { return null; }
			items.push( { id: id, quantity: manquantes[ i ].sachets } );
		}
		if ( ! items.length ) { return null; }
		return items;
	}

	/* Ajout au panier en conservant son contenu, puis redirection vers le panier. */
	resultsWrap.addEventListener( 'click', function( e ) {
		var btn = e.target.closest( '.mdm-corr-buybtn' );
		if ( ! btn || btn.disabled ) { return; }
		var items = null;
		try { items = JSON.parse( btn.getAttribute( 'data-mdm-add' ) ); } catch ( err ) { items = null; }
		if ( ! items || ! items.length ) { return; }
		var label = btn.textContent;
		btn.disabled = true;
		btn.textContent = 'Ajout en cours…';
		fetch( '/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			credentials: 'same-origin',
			body: JSON.stringify( { items: items } )
		} ).then( function( r ) {
			if ( ! r.ok ) { throw new Error( 'ajout refusé' ); }
			return r.json();
		} ).then( function() {
			window.location = '/cart';
		} ).catch( function() {
			btn.disabled = false;
			btn.textContent = label;
			resultsWrap.querySelectorAll( '.mdm-corr-adderr' ).forEach( function( n ) { n.remove(); } );
			var msg = document.createElement( 'p' );
			msg.className = 'mdm-corr-adderr';
			msg.textContent = 'L’ajout au panier a échoué. Réessayez dans un instant.';
			btn.parentNode.appendChild( msg );
		} );
	} );

	function buyMessage( it ) {
		var parts = it.manquantes.map( function( m ) {
			return '<strong>' + m.sachets + ' sachet' + ( m.sachets > 1 ? 's' : '' ) + '</strong> de ' + esc( m.nom ) + ' (' + esc( m.code ) + ')';
		} );
		var txt = 'Pour le réaliser, il vous manque : ' + parts.join( ', ' );
		return '<p class="mdm-corr-buy">' + txt + '.</p>';
	}

	function card( it ) {
		var img = it.img ? '<img src="' + escAttr( it.img ) + '" alt="" loading="lazy">' : '';
		var badge = it.difficulte ? '<span class="mdm-corr-diff">' + esc( it.difficulte ) + '</span>' : '';
		var body = '';
		var cta = '';
		if ( it.match_pct >= 100 ) {
			body += '<p class="mdm-corr-ok">✓ Vous avez toutes les couleurs ! Réalisable dès maintenant.</p>';
			cta = '<a class="mdm-corr-pdf" href="' + escAttr( it.url ) + '">Voir le patron — PDF gratuit ↓</a>';
		} else {
			body += '<p class="mdm-corr-cover">Vous avez <strong>' + it.couleurs_ok + '</strong> couleur' + ( it.couleurs_ok > 1 ? 's' : '' ) + ' sur ' + it.nb_couleurs + ' nécessaires.</p>';
			body += '<div class="mdm-corr-miss-list">' + missingChips( it.manquantes ) + '</div>';
			body += buyMessage( it );
			var items = cartItems( it.manquantes );
			if ( items ) {
				var n = it.total_sachets;
				cta = '<button type="button" class="mdm-corr-buybtn" data-mdm-add="' + escAttr( JSON.stringify( items ) ) + '">' + ( n > 1 ? 'Ajouter les ' + n + ' sachets' : 'Ajouter le sachet' ) + ' — ' + euro( it.cout_estime ) + ' €</button>'
					+ '<a class="mdm-corr-patron" href="' + escAttr( it.url ) + '">Voir le patron — PDF gratuit ↓</a>';
			} else {
				cta = '<a class="mdm-corr-pdf" href="' + escAttr( it.url ) + '">Voir le patron — PDF gratuit ↓</a>';
			}
		}
		var pc = pctClass( it.match_pct );
		return '<article class="mdm-corr-card ' + pc + '">'
			+ '<a class="mdm-corr-card-vis" href="' + escAttr( it.url ) + '">'
			+ ( img ? '<span class="mdm-corr-card-img">' + img + '</span>' : '' )
			+ '<span class="mdm-corr-pct ' + pc + '">' + it.match_pct + '<span class="mdm-corr-pct-u">%</span></span>'
			+ badge
			+ '</a>'
			+ '<div class="mdm-corr-card-body">'
			+ '<h3 class="mdm-corr-card-titre"><a href="' + escAttr( it.url ) + '">' + esc( it.titre ) + '</a></h3>'
			+ body
			+ '<div class="mdm-corr-cta">' + cta + '</div>'
			+ '</div>'
			+ '</article>';
	}

	function injectCss() {
		if ( document.getElementById( 'mdm-corr-buy-css' ) ) { return; }
		var s = document.createElement( 'style' );
		s.id = 'mdm-corr-buy-css';
		s.textContent = '.mdm-corr-cta{margin-top:auto;display:flex;flex-direction:column;gap:6px}'
			+ '.mdm-corr-buybtn{display:block;width:100%;border:0;cursor:pointer;font-family:inherit;text-align:center;background:var(--mm-teal,#0E6E62);color:#fff;font-weight:700;font-size:13px;padding:10px 9px;border-radius:var(--mm-r-md,8px);text-decoration:none;line-height:1.25}'
			+ '.mdm-corr-buybtn:hover{filter:brightness(1.08)}'
			+ '.mdm-corr-buybtn:disabled{opacity:.6;cursor:wait;filter:none}'
			+ '.mdm-corr-adderr{margin:2px 0 0;font-size:12px;color:var(--mm-coral-ink,#A8331B);text-align:center}'
			+ '.mdm-corr-patron{display:block;text-align:center;font-size:12px;color:var(--mm-muted,#6b6257);text-decoration:underline;padding:2px 0}'
			+ '.mdm-corr-patron:hover{color:var(--mm-ink,#211D18)}';
		document.head.appendChild( s );
	}

	function render( data ) {
		if ( ! data || ! data.items ) {
			resultsWrap.innerHTML = '<p class="mdm-corr-hint">Aucun résultat.</p>';
			return;
		}
		injectCss();
		var html = '';

		if ( data.source_titre && data.stock && data.stock.length ) {
			var dots = data.stock.map( function( s ) {
				return '<span class="mdm-corr-stock-item" title="' + escAttr( s.nom + ' (' + s.code + ')' ) + '"><span class="mdm-corr-miss-dot" style="background:' + escAttr( s.hex ) + '"></span>' + intFr( s.qte ) + '</span>';
			} ).join( '' );
			html += '<div class="mdm-corr-source"><p>Avec les perles qu’il vous reste après <strong>' + esc( data.source_titre ) + '</strong> :</p><div class="mdm-corr-stock">' + dots + '</div></div>';
		}

		if ( ! data.items.length ) {
			html += '<p class="mdm-corr-hint">Aucun modèle ne correspond à ce stock pour l’instant.</p>';
			resultsWrap.innerHTML = html;
			return;
		}

		var complet = data.items.filter( function( i ) { return i.match_pct >= 100; } ).length;
		if ( complet > 0 ) {
			html += '<div class="mdm-corr-nobanner mdm-corr-okbanner"><strong>' + complet + '</strong> modèle' + ( complet > 1 ? 's' : '' ) + ' réalisable' + ( complet > 1 ? 's' : '' ) + ' dès maintenant avec votre stock ! Les suivants sont classés du plus au moins réalisable — à pourcentage égal, le moins coûteux à compléter d’abord.</div>';
		} else {
			html += '<div class="mdm-corr-nobanner">Aucun modèle réalisable à 100% avec ce stock. Voici les plus proches, classés <strong>du plus au moins réalisable</strong> — à pourcentage égal, le moins coûteux à compléter d’abord : il ne vous manque souvent qu’un ou deux sachets.</div>';
		}

		html += '<div class="mdm-corr-resume"><span class="mdm-corr-resume-n">' + data.total + '</span> modèle' + ( data.total > 1 ? 's' : '' ) + ' analysé' + ( data.total > 1 ? 's' : '' ) + '.</div>';
		html += '<div class="mdm-corr-cards">' + data.items.map( card ).join( '' ) + '</div>';
		if ( data.total > data.items.length ) {
			html += '<p class="mdm-corr-hint">Affichage des ' + data.items.length + ' meilleures correspondances.</p>';
		}
		resultsWrap.innerHTML = html;
	}

	/* ---------- Deep-link ?modele=<handle|ref> : lance automatiquement le mode A ---------- */
	var params = new URLSearchParams( window.location.search );
	/* 17 oct. 2026 — les pages modèles passent le modèle dans le fragment (#modele=…) : une seule URL
	   de calculateur pour Google au lieu de 251 variantes ?modele=. ?modele= reste accepté. */
	var deep = params.get( 'modele' ) || new URLSearchParams( ( window.location.hash || '' ).replace( /^#/, '' ) ).get( 'modele' );
	if ( deep ) {
		if ( tabs[ 0 ] ) { activate( tabs[ 0 ] ); }
		loadModels().then( function( models ) {
			var src = null;
			models.forEach( function( m ) { if ( m.ref === deep || ( m.modele_url || '' ).indexOf( deep ) > -1 ) { src = m; } } );
			if ( src && search ) { search.value = src._titre; selectedRef = src.ref; if ( goA ) { goA.disabled = false; } }
			run( { modele_source: deep } );
		} );
	}

} )();
